import { render, staticRenderFns } from "./NotificationsBox.vue?vue&type=template&id=0f2d6c59&scoped=true&"
import script from "./NotificationsBox.vue?vue&type=script&lang=js&"
export * from "./NotificationsBox.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBox.vue?vue&type=style&index=0&id=0f2d6c59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d6c59",
  null
  
)

component.options.__file = "NotificationsBox.vue"
export default component.exports